import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

const AuthContext = createContext(null);
const CACHE_KEY = 'hq_user_cache';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || null; }
    catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  async function fetchMe() {
    const token = localStorage.getItem('hq_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const res = await apiFetch('/api/auth/me');
      if (res.status === 401) {
        // Token genuinely rejected — clear session, bounce to login.
        localStorage.removeItem('hq_token');
        localStorage.removeItem(CACHE_KEY);
        setUser(null);
      } else if (res.ok) {
        const data = await res.json();
        setUser(data.user);
        localStorage.setItem(CACHE_KEY, JSON.stringify(data.user));
      }
      // Any other status: keep whatever we have (don't log out on 5xx).
    } catch (e) {
      // Network failure (offline / DNS / 5xx). Use cached session if present;
      // only clear when there's no cache. Lets the iOS PWA open offline.
      // (Intentionally no-op: keep cached user.)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchMe(); }, []);

  function login(token, u) {
    localStorage.setItem('hq_token', token);
    localStorage.setItem(CACHE_KEY, JSON.stringify(u));
    setUser(u);
  }

  function logout() {
    localStorage.removeItem('hq_token');
    localStorage.removeItem(CACHE_KEY);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
